import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './translations/en.json'
import uk from './translations/uk.json'
import de from './translations/de.json'
import fr from './translations/fr.json'
import es from './translations/es.json'
import da from './translations/da.json'
import it from './translations/it.json'
import zh from './translations/zh.json'
import ar from './translations/ar.json'
import ja from './translations/ja.json'

export const SUPPORTED_LANGUAGES = ['en', 'uk', 'de', 'fr', 'es', 'da', 'it', 'zh', 'ar', 'ja']

const resources = {
  en: { translation: en },
  uk: { translation: uk },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  da: { translation: da },
  it: { translation: it },
  zh: { translation: zh },
  ar: { translation: ar },
  ja: { translation: ja },
}

function getInitialLanguage() {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lang')
    if (urlLang && SUPPORTED_LANGUAGES.includes(urlLang)) return urlLang
    const stored = localStorage.getItem('lang')
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored
  } catch {
    /* localStorage / URL may be unavailable */
  }
  return 'en'
}

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // react already protects from xss
  },
})

export default i18n
